import { render, staticRenderFns } from "./phongban.vue?vue&type=template&id=2d40aba2"
import script from "./phongban.vue?vue&type=script&lang=js"
export * from "./phongban.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports